Unit App.Web.Consts;

Interface

Uses
  App.Enumerations,
  Web.Core.Consts;

Type

  TProcessingState = (psStandard, psOpeningData, psSavingData);
  TMainAppPage = (mpNone, mpCRM);
  TAppPage = (
    apNoChange,
    apDashboard,
    apSchools,
    apAcademy,
    apCosting,
    apInvoices,
    apActions,
    apEventViewer,
    apRemittances,
    apCommunications
  );

  TChangeSitePage = Procedure(Const ANewPage: TAppPage; Const ANavDirection: TNavDirection) Of Object;

  TAllDataRequired = Record
    Schools: Boolean;
    Accounts: Boolean;
    Procedure Clear;
    Function AllDone: Boolean;
  End;

Const
  Application_Title = 'CATSC CRM';

  Crumb_No_Change = -1;
  Crumb_Page_One = 0;

Implementation

{ TAllDataRequired }

Function TAllDataRequired.AllDone: Boolean;
Begin
  Result := Schools and Accounts;
End;

procedure TAllDataRequired.Clear;
begin
  Schools := False;
  Accounts := False;
end;

End.
